import Home from '../routes/home.svelte';
import SignupPage from '../routes/signup.svelte';
import VideoPageV2 from '../routes/video-v2.svelte';
import PrivacyPage from '../routes/privacy.svelte';
import TermsPage from '../routes/terms.svelte';
import AboutPage from '../routes/about.svelte';
import ContactPage from '../routes/contact.svelte';
import RealityCheckPage from '../routes/ai-lift.svelte';
import AdminPage from '../routes/admin.svelte';

export const routes = {
  '/': Home,
  '/join': SignupPage,
  '/ai-lift': RealityCheckPage,
  '/video-v2': VideoPageV2,
  '/privacy': PrivacyPage,
  '/terms': TermsPage,
  '/about': AboutPage,
  '/contact': ContactPage,
  '/admin': AdminPage
}; 